import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "otn" }
const _hoisted_2 = ["data-username"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 2,
  class: "fas fa-user-circle otn-avatar-icon"
}
const _hoisted_5 = { class: "otn-name" }
const _hoisted_6 = { class: "otn-meta" }
const _hoisted_7 = {
  key: 1,
  class: "otn-rank otn-rank-hueco",
  "aria-hidden": "true"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "otn-pts-cols" }
const _hoisted_10 = { class: "otn-pts-col otn-pts-col-l" }
const _hoisted_11 = { class: "otn-pts-col otn-pts-col-r" }
const _hoisted_12 = {
  key: 3,
  class: "otn-toggle"
}
const _hoisted_13 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_14 = { class: "otn-pop-name" }
const _hoisted_15 = {
  class: "otn-pop-enr",
  title: "Patrocinador"
}
const _hoisted_16 = {
  key: 2,
  class: "otn-empty otn-empty-l"
}
const _hoisted_17 = {
  key: 3,
  class: "otn-empty otn-empty-r"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_package_icon = _resolveComponent("package-icon")!
  const _component_rank_icon = _resolveComponent("rank-icon")!
  const _component_org_tree_node = _resolveComponent("org-tree-node", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "card",
      class: _normalizeClass(["otn-card", [
        _ctx.statusClass,
        {
          'otn-clickable': _ctx.hasChildren,
          'is-vip': _ctx.isVIP,
          'otn-pop-open': _ctx.showPopover,
        },
      ]]),
      "data-username": _ctx.username,
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      onMouseenter: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.schedulePointsRefresh && _ctx.schedulePointsRefresh(...args))),
      onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelPointsRefresh && _ctx.cancelPointsRefresh(...args)))
    }, [
      (_ctx.node.binarySide)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["otn-side", _ctx.node.binarySide === 'left' ? 'otn-side-l' : 'otn-side-r'])
          }, _toDisplayString(_ctx.node.binarySide === "left" ? "I" : "D"), 3))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["otn-reroot", _ctx.node.binarySide === 'right' ? 'otn-reroot-l' : 'otn-reroot-r']),
        title: "Centrar el árbol en este usuario",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.reroot && _ctx.reroot(...args)), ["stop"]))
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("i", { class: "fas fa-crosshairs" }, null, -1)
      ]))], 2),
      (_ctx.profilePic)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _ctx.profilePic,
            class: "otn-avatar gtr-avatar-bg",
            alt: _ctx.node.nickname
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("i", _hoisted_4)),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.node.nickname || _ctx.node.username), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_package_icon, {
          product: _ctx.UserPackageVisual,
          "extra-class": "otn-pkg",
          colored: "",
          title: _ctx.packageTitle
        }, null, 8, ["product", "title"]),
        _createElementVNode("span", {
          class: _normalizeClass(["otn-days", _ctx.daysClass])
        }, _toDisplayString(_ctx.remainingDays) + "d", 3),
        (_ctx.UserRank)
          ? (_openBlock(), _createBlock(_component_rank_icon, {
              key: 0,
              "icon-class": _ctx.UserRank.iconClass,
              "extra-class": "otn-rank"
            }, null, 8, ["icon-class"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_7))
      ]),
      _createElementVNode("div", {
        class: "otn-pts",
        title: _ctx.pointsTitle
      }, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "otn-pts-title" }, "Puntos", -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "otn-pts-tag" }, "izq", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["otn-pts-val", _ctx.pendingLeftSizeClass])
            }, _toDisplayString(_ctx.pendingLeftText), 3)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "otn-pts-tag" }, "der", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["otn-pts-val", _ctx.pendingRightSizeClass])
            }, _toDisplayString(_ctx.pendingRightText), 3)
          ])
        ])
      ], 8, _hoisted_8),
      (_ctx.hasChildren)
        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("i", _hoisted_13))
              : (_openBlock(), _createElementBlock("i", {
                  key: 1,
                  class: _normalizeClass(["fas", _ctx.expanded ? 'fa-minus' : 'fa-plus'])
                }, null, 2))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "otn-info",
        title: "Detalles",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleInfo && _ctx.toggleInfo(...args)), ["stop"]))
      }, [...(_cache[10] || (_cache[10] = [
        _createElementVNode("i", { class: "fas fa-info" }, null, -1)
      ]))]),
      _createElementVNode("div", {
        class: "otn-pop",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.node.username), 1),
        _createElementVNode("div", _hoisted_15, [
          _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-user-circle fa-fw" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.node.enroller || "—"), 1)
        ])
      ])
    ], 42, _hoisted_2),
    (_ctx.expanded && _ctx.hasChildren && _ctx.childrenPresent)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["otn-kids", {
        'otn-kids-el': !_ctx.leftUsername && !!_ctx.rightUsername,
        'otn-kids-er': !_ctx.rightUsername && !!_ctx.leftUsername,
      }])
        }, [
          (_ctx.leftUsername)
            ? (_openBlock(), _createBlock(_component_org_tree_node, {
                key: 0,
                username: _ctx.leftUsername,
                "expand-depth": _ctx.expandDepth
              }, null, 8, ["username", "expand-depth"]))
            : _createCommentVNode("", true),
          (_ctx.rightUsername)
            ? (_openBlock(), _createBlock(_component_org_tree_node, {
                key: 1,
                username: _ctx.rightUsername,
                "expand-depth": _ctx.expandDepth
              }, null, 8, ["username", "expand-depth"]))
            : _createCommentVNode("", true),
          (!_ctx.leftUsername)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("i", { class: "far fa-circle" }, null, -1)
              ]))]))
            : _createCommentVNode("", true),
          (!_ctx.rightUsername)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, [...(_cache[13] || (_cache[13] = [
                _createElementVNode("i", { class: "far fa-circle" }, null, -1)
              ]))]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}